import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const HighWindExtremeITALegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>
          {t("riskAssessment.highWind")} (ITA) - {t("riskAssessment.extreme")}
        </b>
      </div>
      <div>
        <span style={legendItemStyle("#fff5f0")}></span>
        {t("levels.low")}: 0 &lt; pw &lt; 0.05
      </div>
      <div>
        <span style={legendItemStyle("#fca486")}></span>
        {t("levels.moderate")}: 0.05 &le; pw &lt; 0.10
      </div>
      <div>
        <span style={legendItemStyle("#ea372a")}></span>
        {t("levels.significant")}: 0.10 &le; pw &lt; 0.15
      </div>
      <div>
        <span style={legendItemStyle("#67000d")}></span>
        {t("levels.high")}: pw &ge; 0.15
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pw = {t("legend.windAnnualProbability")} (&gt; 32m/s)
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};

export default HighWindExtremeITALegend;
